import { render, staticRenderFns } from "./ChoicesInput.vue?vue&type=template&id=df36ddc8&scoped=true&"
import script from "./ChoicesInput.vue?vue&type=script&lang=js&"
export * from "./ChoicesInput.vue?vue&type=script&lang=js&"
import style0 from "./ChoicesInput.vue?vue&type=style&index=0&id=df36ddc8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df36ddc8",
  null
  
)

export default component.exports